/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import React from 'react';

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }
	
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null,
      hasError: false
    };
  }
	
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    // Catch errors in any components below and re-render with error message
    console.log("Catch error: ", error);
    console.log("Catch error info: ", errorInfo);
    this.setState({
      error,
      errorInfo
    })
    // You can also log error messages to an error reporting service here
  }
	
  render() {
    if (this.state.hasError) {
      return <p>Error in connection establishment! Loading failed! Please reload.</p>;
    }
		
    if (this.state.errorInfo) {
      // Error pathq
      return (
        <div>
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br/>
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
		
    return this.props.children;
  }
}

export default ErrorBoundary;
